export default import.meta.ROLLDOWN_FILE_URL_q6tfGKm3Qmt5DJmATeHQdA